<template>
	<div class="role">
		<div class="left-menus" v-if="adminId == 1">
			<div class="left-list">
				<div :class="enpId == item.id ? 'left-enp-item-active' : 'left-enp-item'" v-for="item in companyList" :key="item.id" @click="handleEnp(item.id)">
					<div class="enp-item-name">{{item.name}}</div>
				</div>
			</div>
		</div>
		<div class="right-wrap">
			<!-- <div class="query-wrap">
				<div class="qjc-flex">
					<el-select v-model="packageVal" class="query-package" @change="handleChangeSelect">
						<el-option 
							v-for="item in packageList"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						></el-option>
					</el-select>
					<div class="query-date">
						<div class="query-date-label">操作时间</div>
						<el-date-picker
						  v-model="searchDate"
						  type="daterange"
						  value-format="timestamp"
						  range-separator="~"
						  start-placeholder="开始日期"
						  end-placeholder="结束日期"
						  @change="searchDateChange">
						</el-date-picker>
					</div>
				</div>
			</div> -->
			<el-table
				:data="lists"
				style="width: 100%"
				row-key="id"
				:tree-props="{children: 'list', hasChildren: 'hasChildren'}"
				class="list"
			>
			
			<!-- :height="mainHeight - 160 + 'px'" -->
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<el-table-column
					label="操作"
					fixed
					class-name="operate"
					width="120"
				>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.row.old_id >0 }">{{ scope.row.old_id > 0?'修改':'开通' }}</span>
						<span v-if="scope.row.old_id == undefined" >开通</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="created_at"
					fixed
					label="操作时间"
					class-name="created_at"
					width="180"
				>
					<template slot-scope="scope">
						<span v-if="scope.row.created_at">{{ scope.row.created_at ? scope.row.created_at : '--' }}</span>
						<span v-if="scope.row.updated_at" >{{ scope.row.updated_at ? scope.row.updated_at : '--' }}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="mobile"
					label="病人手机号"
					class-name="mobile"
					width="120"
				>
					<template slot-scope="scope">
						{{ scope.row.mobile?scope.row.mobile:'--' }}
					</template>
				</el-table-column>
				<el-table-column
					prop="sex"
					label="性别"
					class-name="sex"
					width="80"
				>
					<template slot-scope="scope">
						{{ scope.row.sex == '1'? '男' : scope.row.sex == '2' ? '女': '--'}}
					</template>
				</el-table-column>
				<el-table-column
					prop="birth"
					label="出生日期"
					class-name="birth"
					width="120"
				>
					<template slot-scope="scope">
						{{ scope.row.birth ? scope.row.birth : '--'}}
					</template>
				</el-table-column>
				<!-- <el-table-column
					prop="examdate"
					label="报告时间"
					class-name="examdate"
					width="120"
				>
					<template slot-scope="scope">
						{{ scope.row.examdate?scope.row.examdate:'--' }}
					</template>
				</el-table-column> -->
				<el-table-column
					prop="doctor"
					label="负责医生"
					class-name="doctor"
					width="120"
				>
					<template slot-scope="scope">
						{{ scope.row.doctor?scope.row.doctor:'--' }}
					</template>
				</el-table-column>
				<el-table-column
					prop="operator"
					label="订单编号"
					class-name="operator"
				>
					<template slot-scope="scope">
						{{ scope.row.order_no ? scope.row.order_no : '--'}}
					</template>
				</el-table-column>
				
			</el-table>
			
			<!-- 分页 -->
				<el-pagination
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper"
					hide-on-single-page
					:current-page.sync="pager.page"
					:page-count="pager.pagecount"
					:page-size="pager.pagesize"
					:total="pager.count"
					@current-change="pageChange">
				</el-pagination>
		</div>
		
		
	</div>
</template>

<script>
	import { adminRole, enterpriseList, getHistory, mainDataQuery, getDoctorOrder } from "@/utils/axios"
	import {Base64} from 'js-base64'
	
	export default{
		name: 'doctorHistory',
		data() {
			return {
				submiting: false,//正在请求
				lists: [],
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
				companyList: [],
				pager: {
					count: 0,
					page: 1,// 默认第一页
					pagecount: 0,
					pagesize: 12//默认一页15条数据
				},
				enpId: '',
				packageList: [
					{
						id: '',
						name: '全部套餐'
					},
					{
						id: '1',
						name: '健康100'
					},
					{
						id: '2',
						name: '自由定制'
					},
					{
						id: '3',
						name: '馨香母婴'
					}
				],
				packageVal: '',
				searchDate: '',//检索日期
				selectRowData: [],// 存储所选列表行数据
				adminId: ''
			}
		},
		mounted() {
			let adminId = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).issupper : '0'
			this.adminId = adminId
			// 获取企业列表
			if(adminId == 1) {
				this.handleEnpList()
			} else {
				this.getHistoryList()
			}
		},
		methods: {
			handleEnpList() {
				getDoctorOrder({act: 'doctor-list'}).then((res) => {
					if(res.code == 200){
						this.companyList = res.data;
						this.companyList.unshift({id: '0', name: '全部'})
						this.enpId = res.data[0].id
						getDoctorOrder({
							act: 'history',
							doctor_id: this.enpId,
							startat: '',
							endat: '',
							page: this.pager.page,
							pagesize: this.pager.pagesize
						}).then(res => {
							if(res.code == 200){
								// 历史记录列表数据
								let list = res.data.data;
								
								this.lists = list
								// 分页
								var pager = res.data.pager;
								for(var key in pager){
									pager[key] = parseInt(pager[key]);
								}
								this.pager = pager;
							}else{
								this.$myAlert({
									type: 'fail',
									content: res.msg
								});
							}
						});
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleEnp(id) {
				this.enpId = id
				this.pager.page = 1
				getDoctorOrder({
					doctor_id: id,
					act: 'history',
					startat: '',
					endat: '',
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}).then(res => {
					if(res.code == 200){
						// 历史记录列表数据
						let list = res.data.data;
						this.lists = list
						// 分页
						var pager = res.data.pager;
						for(var key in pager){
							pager[key] = parseInt(pager[key]);
						}
						this.pager = pager;
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
			// handleEnp(id) {
			// 	this.enpId = id
			// 	this.searchDate = ''
			// 	this.pager.page = 1
			// 	this.getHistoryList()
			// },
			// 查询
			searchDateChange(daterange) {
				this.pager.page = 1
				this.getHistoryList();
			},
			handleChangeSelect(val) {
				this.getHistoryList();
			},
			handleQuery() {
				this.pager.page = 1
				this.getHistoryList();
			},
			pageChange(page) {
				this.pager.page = page;
				this.getHistoryList();
			},
			// 获取列表
			getHistoryList() {
				// page 分页  act 操作类型
				let data = {}
				data = {
					// package: this.packageVal,
					// startat: this.searchDate.length > 0 ? this.searchDate[0] / 1000 : '',
					// endat: this.searchDate.length > 0 ? this.searchDate[1] / 1000 + 86399: '',
					act: 'history',
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}
				getDoctorOrder(data).then(res => {
					if(res.code == 200){
						// 历史记录列表数据
						// this.lists = res.data.data;
						let list = res.data.data;
						// this.lists = res.data.data;
						
						// for(let i = 0; i < list.length; i++) {
						// 	let obj = list[i].haList.pop()
						// 	list[i].birth = obj.birth
						// 	list[i].sex = obj.sex
						// 	list[i].operator = obj.operator
						// }
						this.lists = list
						
						// 分页
						var pager = res.data.pager;
						for(var key in pager){
							pager[key] = parseInt(pager[key]);
						}
						this.pager = pager;
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
		}
	}
</script>

<style scoped>
	.right-wrap >>> .el-table th {
		background-color: #F2F4FA;
	}
	
	.right-wrap >>> .el-date-editor.el-input, .el-date-editor.el-input__inner {
		width: 380px;
	}
	
	.right-wrap >>> .el-date-editor .el-range-separator {
		color: #DBDDE6;
	}
	
</style>
<style lang="scss" scoped>
	.role{
		display: flex;
		padding: 0 24px;
		width: 100%;
		height: 100%;
		border: 12px solid #F2F4FA;
		overflow-y: auto;
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px 0;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				
				&:hover {
					color: #7A92FB;
				}
			}
			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}
			
			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF5219;
				background-color: #FDE8E2;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
			
			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			
			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #DCE3FF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}
		
		.right-wrap {
			position: relative;
			min-width: 1048px;
			height: 100%;
			flex: 1;
			padding: 28px 24px;
			overflow: auto;
			.query-wrap {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 16px;
				
				.query-package {
					width: 226px;
				}
			}
			
			.c-danger{
				color: #FF4C52;
			}
			
			.query-date {
				display: flex;
				align-items: center;
				margin-right: 150px;
				margin-left: 32px;
				
				.query-date-label {
					margin-right: 10px;
				}
			}
			
			.query-btn {
				width: 96px;
				height: 34px;
				background: #6883FB;
				border-radius: 17px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				border: none;
			}
			.el-button:active {
				background-color: #5B73DC;
			}
		}
		
		.foot-pagination {
			// position: absolute;
			// bottom: 0;
			width: 96%;
			padding-bottom: 20px;
			// height: 80px;
		}
		.pagination{
			width: 100%;
			margin-top: 24px;
			text-align: center;
		}
		.empty-wrap {
			padding: 100px 0;
		}
		.empty-img {
			width: 338px;
			height: 218px;
		}
		
	}
</style>
